import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import * as icons from 'react-bootstrap-icons';

export default function GetAppointmentType({ id }) {
    const { appointmentTypes } = useSelector((state) => ({
        appointmentTypes: state.setting.appointmentTypes
    }));
    const [type, setType] = useState(null);
    useEffect(() => {
        setType(null);
    },[])
    useEffect(() => {
        if(appointmentTypes && id) {
            setType(appointmentTypes.find(item => {
                if(item.id === id) {
                    return item
                }
            }))
        } else {
            setType({
                color: '#7E7E7E',
                name: 'در حال بارگزاری',
            })
        }
    },[id, appointmentTypes])

    return (
        <>
            {
                type &&
                <span style={{color: type.color}}>
                    {type.name}
                </span>
            }
        </>
    )
}